import { Space } from "antd";
import DocumentUpload from "../../../../../../components/DocumentUpload/index";

const getSubtitleFromExtensions = (extensions) => {
  const extensionDisplayNames = {
    pdf: "PDF",
    xlsx: "Excel (XLSX)",
    xls: "Excel (XLS)",
    doc: "Word (DOC)",
    docx: "Word (DOCX)",
    jpg: "JPEG Image",
    jpeg: "JPEG Image",
    png: "PNG Image",
    gif: "GIF Image",
    bmp: "BMP Image",
    webp: "WebP Image",
    svg: "SVG Image",
  };

  const typeNames = extensions
    .map((ext) => extensionDisplayNames[ext] || ext.toUpperCase())
    .filter(Boolean);
  const uniqueTypes = [...new Set(typeNames)];

  if (uniqueTypes.length === 1) {
    return `${uniqueTypes[0]} document`;
  } else if (uniqueTypes.length <= 3) {
    return `${uniqueTypes.join(", ")} document`;
  } else {
    return "Multiple file types accepted";
  }
};

const UploadDoc = ({ documents = [], value = [], onChange }) => {
  const handleUpload = (docKey, uploadResult) => {
    // Find the document info from the documents array
    const docInfo = documents.find((doc) => doc._id === docKey);

    const fileExtension =
      uploadResult.file.name.split(".").pop()?.toLowerCase() || "";

    // Create new document object with the uploaded URL
    const newDocObj = {
      _id: docKey,
      documentName: docInfo?.documentName || "",
      document: uploadResult.url,
      documentType: fileExtension,
      fileName: uploadResult.fileName,
    };

    // Update parent component via onChange with functional update
    if (onChange) {
      onChange((prevDocs) => {
        const currentDocs = Array.isArray(prevDocs) ? prevDocs : [];
        
        // Remove existing document with same _id if it exists
        const filteredDocs = currentDocs.filter(doc => doc._id !== docKey);

        return [...filteredDocs, newDocObj];
      });
    }
  };

  const handleRemove = (docKey) => {
    if (onChange) {
      onChange((prevDocs) => {
        const currentDocs = Array.isArray(prevDocs) ? prevDocs : [];
        return currentDocs.filter((doc) => doc._id !== docKey);
      });
    }

    console.log(`Removed ${docKey}`);
  };

  // Transform API documents to component format
  const documentTypes = documents.map((doc) => ({
    key: doc._id,
    title: doc.documentName,
    required: doc.required,
    documentType: Array.isArray(doc.documentType)
      ? doc.documentType
      : [doc.documentType],
  }));

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        {documentTypes.map((doc) => {
          const uploadedDocument = Array.isArray(value)
            ? value.find((uploaded) => uploaded._id === doc.key)
            : null;

          return (
            <DocumentUpload
              key={doc.key}
              title={doc.title}
              subtitle={getSubtitleFromExtensions(doc.documentType)}
              required={doc.required}
              uploadedFile={uploadedDocument}
              onUpload={(uploadResult) => handleUpload(doc.key, uploadResult)}
              onRemove={() => handleRemove(doc.key)}
              documentType={doc.documentType}
            />
          );
        })}
      </Space>
    </Space>
  );
};

export default UploadDoc;
